import script from "./Badge.vue?vue&type=script&setup=true&lang=ts"
export * from "./Badge.vue?vue&type=script&setup=true&lang=ts"

import "./Badge.vue?vue&type=style&index=0&id=294a3be2&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.11.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-294a3be2"]])

export default __exports__